import * as fromFormMapState from './form-map.reducer';

import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

@NgModule({
	imports: [
		StoreModule.forFeature(
			fromFormMapState.formMapFeatureKey,
			fromFormMapState.reducer
		),
	],
})
export class FormMapStateModule {}
